import { convertObjectToCamelCase } from '@/helpers'
import { useMutation } from '@tanstack/react-query'

import { SupplierForecastProps } from '@/types'

import { QUERIES_ADMIN } from './api.constants'
import { api } from './api.service'
import { BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT_URL } from './api.urls'

export const useCreateSupplierForecastWithSupplierProduct = () => {
  const createSupplier = async (
    payload: Partial<SupplierForecastProps>,
  ): Promise<{
    success: boolean
    message: string
    data?: SupplierForecastProps
  }> => {
    try {
      const { data } = await api.post(
        BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT_URL,
        payload,
      )

      return {
        success: true,
        message:
          'Supplier forecast with supplier product created successfully!',
        data: convertObjectToCamelCase(data) as SupplierForecastProps,
      }
    } catch (err) {
      return {
        success: false,
        message: 'Failed to create supplier forecast with supplier product!',
        data: undefined,
      }
    }
  }

  return useMutation({
    mutationKey: [
      QUERIES_ADMIN.BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT.module,
    ],
    mutationFn: (payload: Partial<SupplierForecastProps>) =>
      createSupplier(payload),
  })
}

export const useUpdateSupplierForecastWithSupplierProduct = () => {
  const updateSupplier = async (
    payload: Partial<SupplierForecastProps>,
  ): Promise<{
    success: boolean
    message: string
    data?: SupplierForecastProps
  }> => {
    try {
      const { data } = await api.patch(
        `${BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT_URL}${payload.uuid}/`,
        { ...payload, uuid: undefined },
      )

      return {
        success: true,
        message:
          'Supplier forecast with supplier product updated successfully!',
        data: convertObjectToCamelCase(data) as SupplierForecastProps,
      }
    } catch (err) {
      return {
        success: false,
        message: 'Failed to update supplier forecast with supplier product!',
        data: undefined,
      }
    }
  }

  return useMutation({
    mutationKey: [
      QUERIES_ADMIN.BFF_SUPPLIER_FORECAST_WITH_SUPPLIER_PRODUCT.module,
    ],
    mutationFn: (payload: Partial<SupplierForecastProps>) =>
      updateSupplier(payload),
  })
}
